export default __webpack_public_path__ + "static/media/plus-circle2.de38a616.svg";